<template>
  <v-app>
    <v-app-bar app color="white" light dense>
      <div class="d-flex align-center">
        <v-menu offset-y v-if="applications && applications.length > 0">
          <template v-slot:activator="{ on, attrs }">
            <v-btn v-bind="attrs" v-on="on" small text fab class="ml-0 pl-0"
              ><v-icon small text>mdi-menu</v-icon></v-btn
            >
          </template>
          <v-list>
            <v-list-item
              v-for="(item, index) in applications"
              :key="index"
              @click.stop=""
              v-bind:href="item.path"
            >
              <v-list-item-title>{{ item.name.no }}</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
        <router-link to="/">
          <v-img
            alt="MittFagkart Logo"
            class="shrink mr-2"
            contain
            src="@/assets/mitt-fagkart-logo.png"
            transition="scale-transition"
            width="70"
          />
        </router-link>
        <span v-if="application && application.path !== '/'">{{
          application.name.no
        }}</span>
      </div>

      <v-spacer></v-spacer>
      <span v-if="profile" class="mr-2">{{ profile.name }}</span>
      <v-btn v-if="profile" href="/auth/logout" color="primary" small rounded>
        Logg ut<v-icon class="ml-2" small>mdi-logout</v-icon>
      </v-btn>
      <v-btn
        v-if="!profile"
        :href="'/auth?r=' + $window.location"
        color="primary"
        small
        rounded
      >
        Logg Inn<v-icon class="ml-2" small>mdi-login</v-icon>
      </v-btn>
    </v-app-bar>

    <v-main>
      <!-- <v-container fill-height fluid style="border: 2px solid red;"> -->
      <router-view></router-view>
      <!-- </v-container> -->
    </v-main>
  </v-app>
</template>

<script>
// https://materialdesignicons.com/cdn/2.0.46/
import { mapState } from "vuex";

export default {
  name: "App",

  components: {},

  data: () => ({
    location: ""
  }),
  computed: mapState([
    "applications",
    "homeRedirect",
    "profile",
    "application"
  ]),
  watch: {
    application: {
      handler(val) {
        document.title = [process.env.VUE_APP_NAME, val.name.no].join(" - ");
      },
      deep: true
    },
    homeRedirect(val) {
      if (val === true) {
        window.location = "/";
      }
    }
  },
  methods: {
    loadApplications() {
      this.$store.dispatch("loadApplications");
      setTimeout(this.loadApplications, 30 * 1000);
    },
    loadProfile() {
      this.$store.dispatch("loadProfile");
      setTimeout(this.loadProfile, 30 * 1000);
    }
  },
  created() {
    this.loadApplications();
    this.loadProfile();
  },
  mounted() {}
};
</script>

<style scoped></style>
